/**
 * NotificationManager Component
 */

import * as actions from '../redux/actions/notifications';

import { first, merge } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';

import NotificationUI from '../components/molecules/messaging/Notification';

interface IOwnStateProps {
  nextNotification: INotificationProps;
}

interface IOwnDispacthProps {
  onConsumed: () => any;
}

type NotificationManagerProps = IOwnStateProps & IOwnDispacthProps;

interface IOwnState {
  currentNotification: INotificationProps | null;
}

class NotificationManager extends React.Component<NotificationManagerProps, IOwnState> {
  private globalNotificationProps = {
    open: true,
    onRequestClose: () => this.onNotificationDismiss(),
  };

  constructor(props) {
    super(props);

    this.state = {
      currentNotification: null,
    };
  }

  componentDidMount() {
    if (this.props.nextNotification) {
      this.consumeNotification();
    }
  }

  componentWillReceiveProps({ nextNotification }: NotificationManagerProps) {
    if (nextNotification && this.state.currentNotification === null) {
      this.consumeNotification(nextNotification);
    }
  }

  render() {
    return (this.state.currentNotification &&
      <NotificationUI {...this.state.currentNotification} />
    );
  }

  private onNotificationDismiss = () => {
    this.setState({
      currentNotification: {
        ...this.state.currentNotification!,
        open: false,
      },
    }, () => setTimeout(this.notificationDismissed, 750));
  }

  private notificationDismissed = () => {
    if (this.props.nextNotification) {
      this.consumeNotification();
    } else {
      this.setState({ currentNotification: null });
    }
  }

  private consumeNotification(notification = this.props.nextNotification) {
    this.setState({
      currentNotification: this.prepareNotification(notification),
    }, this.props.onConsumed);
  }

  private prepareNotification(notification: INotificationProps) {
    return merge({}, notification, this.globalNotificationProps);
  }
}

const ConnectedNotificationManager = connect(
  ({ notifications }: IStoreState) => ({
    nextNotification: first(notifications),
  }),
  (dispatch) => ({
    onConsumed: () => {
      dispatch(actions.consumeNotification());
    },
  }),
)(NotificationManager);

export default ConnectedNotificationManager;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/containers/NotificationManager.tsx